export default __webpack_public_path__ + "static/media/checkWhite.2debe242.svg";